import type { SxProps, Theme } from '@mui/material/styles';

export const rootSx: SxProps<Theme> = {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  pt: 2,
};
